import { CModal, CModalBody, CModalHeader, CModalTitle } from "@coreui/react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { useState } from "react";
import { useGetDriverSessions } from "../../hooks/drivers/useDriverSessions";
import Pagination from "../ui/Pagination";

interface SessionModalProps {
  driver: Driver | null;
  onClose: () => void;
  date?: string;
  range?: string;
}

export default function SessionModal({
  driver,
  onClose,
  date,
  range,
}: SessionModalProps) {
  const [page, setPage] = useState(1);

  const { driverSessions, isLoadingSeesion } = useGetDriverSessions(
    driver?.id ?? "",
    {
      page,
      limit: 20,
      ...(date && { date }),
      ...(range && { range }),
    },
  );

  // Render nothing if driver is null
  if (!driver) return null;

  return (
    <CModal
      visible={!!driver}
      onClose={onClose}
      className="position-fixed top-0 end-0 bottom-0 h-100 w-100 overflow-y-auto"
      backdrop={true}
      keyboard={true}
      alignment="center"
      size="lg"
    >
      <CModalHeader>
        <CModalTitle>Sessions - {driver.fullName}</CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          overflowY: "auto",
          maxHeight: "100vh",
        }}
      >
        {isLoadingSeesion ? (
          <p>Chargement des sessions...</p>
        ) : driverSessions?.items?.length ? (
          <ul className="list-group">
            {driverSessions.items.map((session: any, index: number) => (
              <li key={index} className="list-group-item">
                {format(new Date(session.createdAt), "PPPP à HH:mm", {
                  locale: fr,
                })}
              </li>
            ))}
          </ul>
        ) : (
          <p>Aucune session trouvée</p>
        )}
      </CModalBody>
      <Pagination
        currentPage={driverSessions?.meta?.currentPage || 1}
        onPageChange={setPage}
        totalCount={driverSessions?.meta?.totalPages || 1}
        pageSize={driverSessions?.meta?.itemsPerPage}
        siblingCount={1}
      />
    </CModal>
  );
}
